import {all} from '@redux-saga/core/effects';
import accountSaga from 'Users/sagas/SSO/accountSaga';
import accountsSaga from 'Users/sagas/SSO/accountsSaga';
import legacyFormSaga from 'Users/sagas/SSO/legacyFormSaga';

export default function*() {
  yield all([accountsSaga(), accountSaga(), legacyFormSaga()]);
}
